/**
 * **Zenit Hotels**
 *
 * @exports partnership_10015
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
       * @memberOf module:partnership_10015
       */
    partnership.getId = function getId() {
        return '10015';
    };
    /**
       * @memberOf module:partnership_10015
       */
    partnership.check = function check() {
        const hostname = window.location.hostname;
        return hostname.includes('zenithoteles.com') || hostname.includes('goodnightapartments.com');
    };
    const previousHotelIdKey = `${partnership.getId()}:previousPartnershipHotelId`;
    /**
       * @memberOf module:partnership_10015
       */
    partnership.getSiteId = function getSiteId() {
        let result;
        // For the Goodnight Apartments Cádiz hotel we need a different logic because its Index page and R&R are different
        if (window.location.hostname.includes('goodnightapartments.com')) {
            return {
                externalId: document.querySelector('.logo_gn img') && document.querySelector('.logo_gn img').getAttribute('alt'),
            };
        }
        // For the rest of properties
        const idIndex = window.hotelName;
        const idBooking = document.querySelector('[data-idhotel]') && document.querySelector('[data-idhotel]').getAttribute('data-idhotel');
        if (idIndex || idBooking) {
            result = {
                externalId: idIndex || idBooking,
            };
        }
        if (result?.externalId) {
            try {
                window.sessionStorage.setItem(previousHotelIdKey, result.externalId);
            }
            catch (e) { }
        }
        else {
            try {
                const previousPartnershipHotelId = window.sessionStorage.getItem(previousHotelIdKey);
                // Use previousPartnershipHotelId
                result = {
                    externalId: previousPartnershipHotelId,
                };
            }
            catch (e) { }
        }
        if (!result?.externalId) {
            result = {
                accountKey: 'D696E2CE1AB0103CBF698F5286B89632',
            };
        }
        return result;
    };
    return partnership;
}

export { factory };
